import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { CdsFormModal, useForm } from "clayco-component-library";
import ContactModalForm from "./contact-modal-form";
import { RequiredString } from "../../../Components/form_elements/form-validators";

const ContactModal = ({
    data,
    show,
    onSave,
    onCloseModal,
    countries,
    relationships,
    setPrimary,
    update
}) => {
    const { reset } = useForm();

    const contactFormSchema = (clearErrors) => yup.object().shape({
        firstName: RequiredString("First Name is required"),
        lastName: RequiredString("Last Name is required"),
        relationship: RequiredString("Relationship is required"),
        areaCode: RequiredString("Area Code is required")
            .test('test-areaCode', 'Please enter a valid code', function(value){
                var int = yup.ref('international').getValue(null, this.parent, this);
                console.log(int);
                if (clearErrors){
                    clearErrors();
                }

                if (int){
                    return value.startsWith("+") ? true : false;
                }
                else
                    return value.length === 3;
            }),
        international: yup.bool(),
        isPrimary: yup.bool(),
        phoneNumber: RequiredString("Phone Number is required")
            .test('test-phoneNumber', 'Please enter a valid phone number', function(value){
                var int = yup.ref('international').getValue(null, this.parent, this);
                if(clearErrors){
                    clearErrors();
                }

                if (int){
                    // if international, validate 20 char max
                    if (value.length <= 20){
                        return true;
                    }
                    
                    return false;
                }
                else{
                // if us, validate 3-4 / 7 total
                    if (value.length < 8 || value.length > 8)
                        return false;

                    return true;
                }
            }),
        address1: yup.string().nullable(),
        address2: yup.string().nullable(),
        country: yup.string().nullable(),
        state: yup.string().nullable(),
        city: yup.string().nullable(),
        postalCode: yup.string().nullable()
    });

    useEffect(() => {
        if (!show) {
            reset();
            onCloseModal(false);
        }
    }, [show]);

    function handleError(data) {
        console.log(data);
    }

    const saveDegree = async (formData) => {
        formData.id = data.id;
        onSave(formData);
        reset()
    };

    const handleClose = () => {
        reset();
        onCloseModal();
    }

    return (
        <>
            <CdsFormModal
                title={data?.id ? "Edit Contact" : "Add a Contact"}
                schema={contactFormSchema}
                onError={handleError}
                onSubmit={saveDegree}
                show={show}
                handleCloseClick={onCloseModal}
            >
                <ContactModalForm
                    data={data}
                    countries={countries}
                    relationships={relationships}
                    setPrimary={setPrimary}
                    update={update}
                />
            </CdsFormModal>
        </>
    );
};

export default ContactModal;
